import { render, staticRenderFns } from "./invite_origin.vue?vue&type=template&id=10bf2cb9&scoped=true&"
import script from "./invite_origin.vue?vue&type=script&lang=js&"
export * from "./invite_origin.vue?vue&type=script&lang=js&"
import style0 from "./invite_origin.vue?vue&type=style&index=0&id=10bf2cb9&lang=less&scoped=true&"
import style1 from "./invite_origin.vue?vue&type=style&index=1&id=10bf2cb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf2cb9",
  null
  
)

export default component.exports